import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

import Sortus from './Sortus.js' // By Guillermo G. Ugalde Vergara

import Inquilinos1  from './Inquilinos.vue'
import Propiedades1 from './Propiedades.vue'
import Contratos1   from './Contratos.vue'
import Movimientos1 from './Movimientos.vue'
import Usuarios1 from './Usuarios.vue'

import InquilinoVer1    from './Inquilino-ver.vue'
import InquilinoAgrega1 from './Inquilino-agregar.vue'
import InquilinoEditar1 from './Inquilino-editar.vue'

import PropiedadVer1    from './Propiedad-ver.vue'
import PropiedadAgrega1 from './Propiedad-agregar.vue'
import PropiedadEditar1 from './Propiedad-editar.vue'

import ContratoVer1    from './Contrato-ver.vue'
import ContratoAgrega1 from './Contrato-agregar.vue'
import ContratoEditar1 from './Contrato-editar.vue'
import ContratoEstado1 from './Contrato-estado.vue'

import ContratosRenovacion1 from './Contratos-renovacion.vue'


import MovimientoVer1    from './Movimiento-ver.vue'
import MovimientoAgrega1 from './Movimiento-agregar.vue'

import SeleccionarPropiedad1 from './Propiedad-seleccionar.vue'

import ContratosReporte1 from './Contratos-reporte.vue'

import Pagos1 from './Pagos.vue'

import Reporteador1 from './Reporteador.vue'

import UsuarioAgrega1 from './Usuario-agregar.vue'
import UsuarioEditar1 from './Usuario-editar.vue'

import FormatoAgrega1 from './Formato-agregar.vue'
import Estados1 from './Estados-de-cuenta.vue'

import LeerReporte from './ReportesHechos'

import ComprarRentus from './Comprar-Rentus'


Vue.use(VueRouter);

// SORTUS. AUTOR GUILLERO G. UGALDE VERGARA
Vue.use(Sortus);

var routes = [

	{path:'/inq', component: Inquilinos1},
	{path:'/pro', component: Propiedades1},
	{path:'/con', component: Contratos1},
	{path:'/mov', component: Movimientos1},
	{path:'/usu', component: Usuarios1},
	{path:'/pagos', component: Pagos1},
	{path:'/rep', component: Reporteador1},
	{path:'/inq-ver/id', name:'ver-inqui', component: InquilinoVer1},
	{path:'/inq-edi/id', name:'edi-inqui', component: InquilinoEditar1},
	{path:'/inq-agrega', name:'agre-inqui',component: InquilinoAgrega1},
	{path:'/pro-ver/id', name:'ver-propi', component: PropiedadVer1},
	{path:'/pro-edi/id', name:'edi-propi', component: PropiedadEditar1},
	{path:'/pro-agrega', name:'agre-propi',component: PropiedadAgrega1},
	{path:'/con-agrega', name:'agre-con',component: ContratoAgrega1},
	{path:'/con-ver/id', name:'ver-con', component: ContratoVer1},
	{path:'/con-edi/id', name:'edi-con', component: ContratoEditar1},
	{path:'/con-edo/id', name:'edo-con', component: ContratoEstado1},
	{path:'/mov-agrega', name:'agre-movi',component: MovimientoAgrega1},
	{path:'/mov-ver/id', name:'ver-movi', component: MovimientoVer1},
	{path:'/pro-sel', name:'sel-pro', component: SeleccionarPropiedad1},
	{path:'/con-rep', name:'rep-con', component: ContratosReporte1},
	{path:'/usu-agrega', name:'agre-usu', component: UsuarioAgrega1},
	{path:'/usu-editar', name:'edi-usu', component: UsuarioEditar1},
	{path:'/for-agrega', name:'agre-for', component: FormatoAgrega1},
	{path:'/pagos/id', name:'pago', component: Pagos1},
	{path:'/edos-cta', name:'edos-de-cta', component: Estados1},
	{path:'/leer-repor', name:'repor-leer',component: LeerReporte},
    {path:'/reno-cont', name:'cont-reno',component: ContratosRenovacion1},
    {path:'/rent-comp', name:'comp-rent',component: ComprarRentus}

];

const router = new VueRouter({
	routes,
	mode: 'history'
})

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js